<main class="auth flex">
    <div class="auth__content flex-wrap">
        <aside class="auth__left">
            <img src="assets/images/auth.png" alt="Auth" />
        </aside>
        <aside class="auth__right">
            <img src="assets/images/logo-dark.svg" alt="Logo" />
            <form [formGroup]="loginForm" (submit)="onSignin()">
                <h1>Admin Login</h1>
                <div class="input-field">
                    <label>Email*</label>
                    <input type="text" formControlName="email" placeholder="Email" />
                    <span *ngIf="loginForm.get('email')?.errors?.['required']&&(loginForm.get('email')?.dirty||loginForm.get('email')?.touched)">
                        Email is required
                    </span>
                    <span *ngIf="loginForm.get('email')?.errors?.['pattern']&&loginForm.get('email')?.dirty">
                        Please enter a valid email
                    </span>
                </div>

        <div class="input-field">
          <label>Password*</label>
          <input
            [type]="showPassword?'text':'password'"
            formControlName="password"
            placeholder="Password"
          />
          <span
            *ngIf="loginForm.get('password')?.errors?.['required']&&(loginForm.get('password')?.dirty||loginForm.get('password')?.touched)"
          >
            Password is required
          </span>
          <img *ngIf="showPassword" src="assets/images/eye-close.svg" alt="Show" (click)="showPassword=false"/>
          <img *ngIf="!showPassword" src="assets/images/eye-open.svg" alt="Hide" (click)="showPassword=true"/>
        </div>
        <app-button
          customClass="isFull"
          [isLoading]="isLoading"
          [label]="'Login'"
          type="submit"
          [isDisabled]="isLoading"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </form>
    </aside>
  </div>
</main>

<ng-template #buttonLoading> </ng-template>
